import { createContext, useContext } from 'react';

import {
  type ModalFooterButtonLabelMapByEvent,
  type ModalFooterButtonVariantMapByEvent,
  type ModalFooterContextParams,
} from './types';

const InitialModalFooterButtonVariantMapByEvent: ModalFooterButtonVariantMapByEvent = {
  cancel: 'tertiary',
  close: 'tertiary',
  submit: 'primary',
  delete: 'danger',
  confirm: 'primary',
  common: 'primary',
};

const InitialModalFooterButtonLabelMapByEvent: ModalFooterButtonLabelMapByEvent = {
  cancel: '취소',
  close: '닫기',
  submit: '적용',
  delete: '삭제',
  confirm: '확인',
  common: '확인',
};

const ModalFooterContext = createContext<ModalFooterContextParams>({
  variantMap: InitialModalFooterButtonVariantMapByEvent,
  loading: false,
  labelMap: InitialModalFooterButtonLabelMapByEvent,
});

const useModalFooterContext = () => {
  const context = useContext(ModalFooterContext);

  return context;
};

export {
  ModalFooterContext,
  useModalFooterContext,
  InitialModalFooterButtonLabelMapByEvent,
  InitialModalFooterButtonVariantMapByEvent,
};
